import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
	selector: 'ras-menu-button',
	templateUrl: './menu-button.component.html',
	styleUrls: ['./menu-button.component.sass']
})
export class MenuButtonComponent implements OnInit {

	@Input() active: boolean
	@Output() activeChange = new EventEmitter<boolean>()

	constructor() { }

	ngOnInit() {
	}

	toggle() {
		this.active = !this.active
		this.activeChange.emit(this.active)
	}

}
